// extracted by mini-css-extract-plugin
export default {"image":"style_image__EX89x","is-loaded":"style_is-loaded__t4wf+"};